import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, from, of } from 'rxjs';
import { map, take, switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth/auth.service';

@Injectable({
	providedIn: 'root'
})

export class AutoLoginGuard implements CanActivate {

	constructor(
		private auth: AuthService,
		private router: Router,
	) { }

	canActivate(): Observable<boolean | UrlTree> {

		return this.auth.isAuthenticated.pipe(
			take(1), // Tomamos el primer valor emitido
			switchMap(isAuthenticated => {
				console.log('AutoLoginGuard - isAuthenticated:', isAuthenticated);

				if (!isAuthenticated) return of(true); // permitir ver /login

				// Ya autenticado: redirigir según "modo" definido en AuthService
				switch (this.auth.mode) {					
					case 'admin':
						return of(this.router.createUrlTree(['/admin/accounts']));
					case 'abc':
						return of(this.router.createUrlTree(['/code'])); // tu dashboard ABC
					default:
						console.log(this.auth.mode);
						// Si no hay modo válido, mandamos a login (más rápido) o disparás logout abajo
						return from(this.auth.logOut({ skipNavigate: true }))
							.pipe(map(() => this.router.createUrlTree(['/login'])));
				}
			})
		);
	}
}
